import api from "../config/apiConfig";
import { getAdminId } from "../utils/authId";
import { toast } from "react-toastify";

export const FetchLogs = async (data) => {
  const adminId = getAdminId();
  try {
    const response =
      await api.get(`api/get_history_details/?admin_id=${adminId}${data}
`);
    return response.data;
  } catch (error) {
    throw error;
  }
};

//clear Logs

export const ClearLogsApi = async (data) => {
  const adminId = getAdminId();
  try {
    const datas = {
      admin_id: adminId,
      ...data,
    };
    const response = await api.post(`api/delete_history/`, datas);
    toast.success("Deleted successful!", {
      position: "top-center",
      autoClose: 2000,
      closeButton: false,
      className: "custom_toast",
    });
    return response.data;
  } catch (error) {
    throw error;
  }
};

// Get Selected logs

export const SelectedLog = async (data) => {
  try {
    const response = await api.get(`api/selected_history_details/${data}`);
    return response.data;
  } catch (error) {
    throw error;
  }
};
